import type { ReactNode } from "react";
import "./input-text.css";

interface InputTextProps {
    error?: string;
    className?: string;
    name: string;
    label?: string | ReactNode;
    password?: boolean;
    placeholder?: string;
    value?: string;
    onChange?: React.ChangeEventHandler<HTMLInputElement>;
    variantError?: boolean;
}

export const InputText = ({className, error, label, name, password= false, placeholder, value, variantError, onChange}: InputTextProps) => {
    return (
        <div className={`${className} input-text-container`}>
            {label && <div className="input-text-label">{label}</div>}
            <input 
                className={`input-text  ${!!error || variantError ? "input-error" : ""}`} name={name}   
                value={value}
                onChange={onChange}
                type={password ? "password" : "text"} 
                placeholder={placeholder} >
                </input>
            {error && <p className="input-error-message">{error}</p>}
        </div>
    )
};